import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'

import {
  UserMenu,
  NotificationsIcon,
  MyLeader,
  UserGuide,
  AssessorGuide,
  Image,
} from 'containers/misc'
import { Logo } from 'components/misc'
import MODALS from 'constants/layout/modals'
import { modal } from 'helpers/decorators'
import styles from './header.styl'
import getHeaderColorStyle from 'helpers/getHeaderColorStyle'
import config from 'config'
import { connect } from 'react-redux'
import { AWARD_TYPES, LEVELS } from '../../../constants/enums'

const headerColorStyle = getHeaderColorStyle()

@modal.trigger()
@connect(({ api }) => ({
  awardCustomization: api.awards.customization
}))
class HeaderDashboard extends Component {
  static propTypes = {
    awards: PropTypes.object,
    onOpen: PropTypes.func,
    indexRoute: PropTypes.string,
    className: PropTypes.string,
    isAssessor: PropTypes.bool,
    push: PropTypes.func,
    awardCustomization: PropTypes.object
  }

  getActions = (isAssessor, hideChangeMajor) =>
    [
      {
        id: 'profile',
        intlKey: 'label.profile',
        label: 'Profile',
        onClick: this.openProfileDetails
      },
      {
        id: 'settings',
        intlKey: 'label.settings',
        label: 'Settings',
        onClick: this.openSettings
      },
      {
        id: 'awardSummary',
        intlKey: 'label.award_summary',
        label: 'Award Summary',
        onClick: this.openAwardSummary
      },
      ...(isAssessor ? [
        {
          id: 'affiliationsOverview',
          intlKey: 'label.affiliations_overview',
          label: 'Affiliations Overview',
          onClick: this.openAffiliationsOverview
        },
        {
          id: 'wwcStatus',
          intlKey: 'label.wwc_status',
          label: 'WWC status',
          onClick: this.openWWCStatus
        }
      ] : []),
      {
        id: 'majorActivity',
        intlKey: 'label.change_major_activity',
        label: 'Change major activity',
        onClick: this.openChangeMajorActivity
      },
      {
        id: 'logout',
        intlKey: 'label.logout',
        label: 'Logout',
        action: `${config.publicPath}/logout`
      }
    ].filter(item => {
      if (isAssessor) {
        return !['majorActivity', 'awardSummary'].includes(item.id)
      }
      if (hideChangeMajor) {
        return !['majorActivity'].includes(item.id)
      }
      return true
    })

  openChangeMajorActivity = () =>
    this.props.onOpen(MODALS.CHANGE_MAJOR_ACTIVITY)
  openSettings = () => this.props.onOpen(MODALS.SETTINGS)
  openProfileDetails = () => this.props.onOpen(MODALS.PROFILE_DETAILS)
  openAffiliationsOverview = () => this.props.onOpen(MODALS.AFFILIATIONS_OVERVIEW)
  openWWCStatus = () => this.props.onOpen(MODALS.WWC_STATUS)

  openAwardSummary = () =>
    this.props.push(this.props.indexRoute + '/award-summary')

  render() {
    const { awards, className, indexRoute, isAssessor, awardCustomization } = this.props
    const isSimplified = get(awards, 'awardType.value') === AWARD_TYPES.simplified.id
    const isBronze = get(awards, 'awardLevel.value') === LEVELS.BRONZE.id
    const isSimplifiedBronze = isSimplified && isBronze
    const hideChangeMajor = get(awards, 'majorActivityNeeded') === false || isSimplifiedBronze
    const actions = this.getActions(isAssessor, hideChangeMajor)
    const showLogo = awardCustomization.loaded
    const logoUrl = awardCustomization.logoUrl

    return (
      <header
        className={`${styles.header} ${className && className}`}
        style={headerColorStyle}
      >
        <div className={styles.separators}>
          <div className={styles.separator1} />
          <div className={styles.separator2} />
          <div className={styles.separator3} />
          <div className={styles.separator4} />
          <div className={styles.separator5} />
        </div>
        <div className={styles.inner}>
          <div className={styles.logo}>
            {showLogo && logoUrl && <Image src={logoUrl} alt="Duke of Edinburgh" />}
            {showLogo && !logoUrl && <Logo to={indexRoute} />}
          </div>

          {!isAssessor && (
            <div className={`${styles.menu} ${styles.hideMd}`}>
              <MyLeader />
            </div>
          )}
          {!isAssessor ? (
            <div className={`${styles.menu} ${styles.hideMd}`}>
              <UserGuide />
            </div>
          ) : (
            <div className={`${styles.menu} ${styles.hideMd}`}>
              <AssessorGuide />
            </div>
          )}

          <div className={styles.right}>
            {!isAssessor && <NotificationsIcon />}
            <div className={styles.hideMd}>
              <UserMenu actions={actions} />
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default HeaderDashboard
